import {Component, OnDestroy, OnInit} from '@angular/core';
import {forkJoin, Observable, from} from "rxjs";
import {map} from "rxjs/operators";
import {Centre} from "../../../../interfaces/Centres";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {FullChild} from "../../../../interfaces/FullChild";
import {CentreService} from "../../../../services/centre.service";
import {ChildService} from "../../../../components/child/child.service";
import {CounselingService} from "../../counseling.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {MatDialogRef} from "@angular/material/dialog";
import {MatSelectChange} from "@angular/material/select";
import {TitleCasePipe} from "@angular/common";
import {LogService} from "../../../../services/log.service";
import {Subject} from "rxjs/internal/Subject";
import {GlossaryService} from "../../../../components/glossary/glossary.service";
import {takeUntil} from "rxjs/internal/operators/takeUntil";
import {AngularFireDatabase} from "@angular/fire/compat/database";
export interface CentreSelection{
    centreName:string
    centreCode:string
}
@Component({
    selector: 'app-add-group-session',
    templateUrl: './add-group-session.component.html',
    styleUrls: ['./add-group-session.component.scss']
})
export class AddGroupSessionComponent implements OnInit, OnDestroy {
    types=["Admission Counselling","Regular Counselling","Follow Up Counselling","Discharge Counselling","Others"]
  disabledSubmit=false

userName:any
maxDate=new Date()
    centres$: Observable<Centre[]>
    form: FormGroup
    selectedChildrens?:any[]
    parents?:string[]
    children$?: Observable<FullChild[]>
  mGlossaryData:any
  destroyed$ = new Subject()

  selectedCentre:any;
  displayCentre = (c: any) => c?.centreName;

  childSearchControl = new FormControl('');
  filteredChildData: FullChild[] = [];
  fullChildrenData: FullChild[] = [];




  startTime: any
    endTime: any
    centreSelect = new FormControl<string | null>('', [Validators.required]);
  childSelect = new FormControl<FullChild[]>([], {validators: [Validators.required], nonNullable: true});

    _topiceCovered$: Observable<String[]>;
    constructor(private centreService: CentreService,
                private childService: ChildService,
                private counsellingService: CounselingService,
                private _snackBar: MatSnackBar,
                private readonly mLogService:LogService,
                private readonly mDatabase:AngularFireDatabase,

                private readonly mGlossary: GlossaryService,


                private titlecasePipe: TitleCasePipe,
                private readonly matDialogRef:MatDialogRef<AddGroupSessionComponent>
                // private dialogRef:MatDialogRef<AddGroupSessionComponent>
    ) {
        this._topiceCovered$ = this.mDatabase.list<String>('types/Topics Covered').valueChanges()

        this.centres$ = this.centreService.getAllCentres()
        const userData=JSON.parse( localStorage.getItem('userData')!)
        this.userName=userData?.userName
        this.form = new FormGroup({
            centreName: new FormControl('', Validators.required),
            centreCode: new FormControl('', Validators.required),
            centres: new FormControl('', Validators.required),
            // parents: new FormControl(this.parents, Validators.required),
            children: new FormControl('', Validators.required),
            // childCodes: new FormControl('', Validators.required),
            startTime: new FormControl('', Validators.required),
            endTime: new FormControl('', Validators.required),
            date: new FormControl('', Validators.required),
            // description: new FormControl('', Validators.required),
            participants: new FormControl('', Validators.required),
            topicsCovered: new FormControl('', Validators.required),
            issue: new FormControl('', Validators.required),
            intervention: new FormControl('',),
            takeaway: new FormControl('', Validators.required),
            // type: new FormControl('', Validators.required),
            createdAt:new FormControl(Date.now()),
            submittedBy:new FormControl(this.userName),

            // childCode:new FormControl('',Validators.required),
        })
    }
    ngOnInit(): void {
      this.mGlossary.fetchCounsellingGlossary().pipe(takeUntil(this.destroyed$)).subscribe(res=>{

        this.mGlossaryData  =res
      })

      this.childSearchControl.valueChanges.pipe(takeUntil(this.destroyed$)).subscribe(search => {
        const value = (search || '').toLowerCase();

        this.filteredChildData = this.fullChildrenData.filter(c =>
          (c.firstName + ' ' + c.lastName).toLowerCase().includes(value)
        );
      });

    }

    ngOnDestroy(): void {
      this.destroyed$.next(null);
      this.destroyed$.complete();
    }


  onCentreSelect(selectedCentre: Centre) {
    if (!selectedCentre) return;

    console.log("Selected Centre:", selectedCentre);

    this.selectedCentre = selectedCentre;
    this.form.patchValue({
      centreName: selectedCentre.centreName,
      centreCode: selectedCentre.centreCode
    });

    // -----------------------------------------------------
    // 2️⃣ MERGED fetchChildren() LOGIC (your old logic EXACT)
    // -----------------------------------------------------

    let centreCodes: string[] = [];
    let centreNames: string[] = [];
    let allcentres: any[] = [];

    centreCodes.push(selectedCentre.centreCode);
    centreNames.push(selectedCentre.centreName);

    allcentres.push({
      centreName: selectedCentre.centreName,
      centreCode: selectedCentre.centreCode
    });

    console.log("Centre Codes:", centreCodes);
    console.log("Centre Names:", centreNames);

    // 🔥 Fetch children based on selected centre
    this.children$ = this.childService.getAllotedChildListByCenterarray(centreCodes);

    this.childService
      .getAllotedChildListByCenterarray(centreCodes)
      .subscribe(res => {
        console.log("Children fetched:", res);
        // No conversion required here unless needed later


        // Convert to array
        this.fullChildrenData = res;

        // Attach to filter list for search dropdown
        this.filteredChildData = [...this.fullChildrenData];
      });

    // Set centres array in form
    this.form.get('centres')?.setValue(allcentres);
  }

  onChildDropdownOpen() {
    this.childSearchControl.setValue('');
    this.filteredChildData = [...this.fullChildrenData];
  }



  fetchChildren($event: MatSelectChange) {
        let centres = $event.value
        let centreCodes: String[] = []
        let centreNames: String[] = []
        let allcentres:any[]=[]
        centreCodes.push(centres.centreCode)
        centreNames.push(centres.centreName)
        // centres.forEach(v => {
        //     centreCodes.push(v.centreCode)
        //     centreNames.push(v.centreName)
        allcentres.push({
            centreName:centres.centreName,
            centreCode:centres.centreCode
        })

        console.log(centreCodes)
        console.log(centreNames)
        // alert(centre)
        this.children$ = this.childService.getAllotedChildListByCenterarray(centreCodes)
        this.childService.getAllotedChildListByCenterarray(centreCodes).subscribe(res=>{
            console.log(res)
        }
        )
        this.form.get('centres')?.setValue(allcentres)
        // this.form.get('centreCode')?.setValue(centres.centreCode)
    }

    onChildSelect($event: MatSelectChange) {
        let children = $event.value as FullChild[]
        let childrens: any[] = []
        let childNames: String[] = []
        children.forEach(v => {
      const parentsName=  v.guardians[1] ? ( v.guardians[0]?.firstName +  ' and '+v.guardians[1]?.firstName ) :  ( v.guardians[0]?.firstName +  ' NA');

            childrens.push({
                'childCode': v.childCode,
                'childName': v.firstName +' '+ v.lastName,
                'parentsName':parentsName,
            })
            childNames.push(v.firstName + " " + v.lastName)
            // let p = (v.guardians[0]?.firstName +' and '+v.guardians[1]?.firstName).toString()
            // console.log('p',p)
            // this.parents?.push(p)
            // console.log(this.parents)
        })

        // this.form.get('childCodes')?.setValue(childCodes)
        this.form.get('childNames')?.setValue(childNames)
        this.form.get('children')?.setValue(childrens)
        // @ts-ignore
        this.selectedChildrens = childrens
    }

    Submit() {
      this.form.patchValue({
        centreName: this.selectedCentre?.centreName,
        centreCode: this.selectedCentre?.centreCode
      });
        if (this.form.valid) {
          this.disabledSubmit =true
          console.log(this.form)
            this.counsellingService.addGroupSession(this.form.value).then(() => {
                this._snackBar.open('Session Submitted')._dismissAfter(3000)
              // Get child name and centre name for dynamic description
              const childName = this.form.get('childName')?.value;
              const centreName = this.form.get('centreName')?.value ;
              const childCode = this.form.get('childCode')?.value ;
              let activity={
                date:new Date().getTime(),
                section: 'Group Counseling',
                action: 'Submit',
                description: `Group Session added to Counseling for ${childName} at ${centreName} (center code :-${childCode}) by user`,
                currentIp: localStorage.getItem('currentip')!
              }
              this.mLogService.addLog(activity)
                this.matDialogRef.close()
            })
        } else {
            this._snackBar.open('Please enter the form carefully')._dismissAfter(3000)
            console.log(this.findInvalidControls())
        this.disabledSubmit =false
        }

    }

    Cancel() {
        this.matDialogRef.close()
    }
    public findInvalidControls() {
        const invalid = [];
        const controls = this.form.controls;
        for (const name in controls) {
            if (controls[name].invalid) {
                invalid.push(name);
            }
        }
        return invalid;
    }
    onBlur(formControl: any) {
        if(formControl.value !== null) {
            formControl.setValue(capitalizeSentence(formControl.value.toString()))
        }
    }

}
function capitalizeSentence(sentence:string) {
    if (!sentence) return ''; // Handle empty input

    const words = sentence.split(' ');
    const capitalizedWords = words.map(word => {
        if (word.length > 0) {
            return word[0].toUpperCase() + word.slice(1).toLowerCase();
        }
        return word;
    });

    return capitalizedWords.join(' ');
}

